import { z } from 'zod';
import { moneySchema } from '../moneySchema';

export const fundingRequestTotalsSchema = z.object({
  year: z.number(),
  budgetForFundingRequests: moneySchema,
});

export type FundingRequestTotals = z.infer<typeof fundingRequestTotalsSchema>;
